module.exports = __webpack_public_path__ + "static/media/Deli_Check.97be0f50.svg";